module.exports = __webpack_public_path__ + "img/p2-89.d400850c.png";